/**
 * Helper to ensure captions are always returned and displayed purely in sentence structure.
 * Strips any raw JSON structure, tokens, keys, escaped quotes, or brackets.
 */
export const cleanCaptionSentence = (text) => {
  if (!text || typeof text !== "string") return "";
  let clean = text.trim();

  // If text contains embedded JSON keys like "text": "sentence..."
  if (clean.includes('"text":') || clean.includes("'text':")) {
    const m = clean.match(/["']text["']\s*:\s*["']((?:[^"'\\]|\\.)*)["']/);
    if (m && m[1]) {
      clean = m[1];
    }
  }

  // Strip JSON formatting characters, keys, braces, brackets
  clean = clean
    .replace(/^\{?\s*["']?captions["']?\s*:\s*\[?/gi, "")
    .replace(/^\{?\s*["']?style["']?\s*:\s*["'][^"']*["'],?/gi, "")
    .replace(/^["']?text["']?\s*:\s*/gi, "")
    .replace(/^[\{\}\[\]]+\s*/, "")
    .replace(/\s*[\{\}\[\]]+$/, "")
    .replace(/\\"/g, '"')
    .replace(/\\n/g, ' ')
    .trim();

  // Remove leading and trailing quotation marks
  clean = clean.replace(/^["']+|["']+$/g, "").trim();

  // In case of any leftover trailing JSON syntax like ", { style: ..."
  clean = clean.replace(/",?\s*\{.*$/i, "").trim();
  clean = clean.replace(/^["']+|["']+$/g, "").trim();

  // If after cleaning it still contains raw JSON or braces, reject it
  if (clean.startsWith("{") || clean.startsWith("[") || clean.includes('"captions"') || clean.includes('"style"') || clean.includes('"text"')) {
    return "";
  }

  return clean;
};
